var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map"},[_c('a',{attrs:{"href":"https://www.here.com/","target":"_blank","rel":"noopener"}},[_c('img',{staticClass:"here-logo",attrs:{"src":require("@/assets/here-logo.png"),"width":"160","height":"103","alt":"Here"}})])])
}]

export { render, staticRenderFns }